import React, { FC } from 'react'
import { ButtonPrimary } from 'front-end/src/components'
import {
  RetryResourceMutationHookResult,
  useRetryResourceMutation
} from 'front-end/src/pages/topic-detail-page/RetryResourceQuiz.codegen'

export const StartScormCourseButton: FC<{
  topicId: number
  link: string
  consumeAttempt?: boolean
  onConsumeAttempt?: (data: RetryResourceMutationHookResult) => void
}> = ({ children, topicId, link, consumeAttempt, onConsumeAttempt }) => {
  const [retryResource] = useRetryResourceMutation({
    onCompleted: (data) => onConsumeAttempt && onConsumeAttempt(data)
  })

  return (
    <ButtonPrimary
      size="lg"
      onClick={async () => {
        if (consumeAttempt) {
          await retryResource({
            variables: {
              topicId
            }
          })
        }
        if (!onConsumeAttempt) {
          window.open(`${link}` || '', '_self')
        }
      }}
    >
      {children}
    </ButtonPrimary>
  )
}
